import {createAction, props} from '@ngrx/store';
import {ProleisObject} from '@proleis/proleis-rest-client';
import {Options} from 'highcharts';
import {ValidatePboModel} from '../../../services/suppliers.service';

export const LOAD_PLANNED_DELIVERIES = createAction(
  '[Deliveries] load planned deliveries',
  props<{ orderId: string, posId: string }>()
);

export const LOAD_PLANNED_DELIVERIES_SUCCESS = createAction(
  '[Deliveries] planned deliveries loaded',
  props<{ deliveries: ProleisObject[] }>()
);

export const LOAD_PLANNED_DELIVERIES_ERROR = createAction(
  '[Deliveries] error while loading planned deliveries'
);

export const CREATE_PLANNED_DELIVERY = createAction(
  '[Deliveries] create planned delivery',
  props<{
    pboId: string,
    posId: string,
    plannedDate: Date,
    plannedCount: number,
    subtypeGuid: string,
    deliveryNoteNumber?: string,
    deliveryComment?: string,
    incidentId?: string
  }>()
);

export const CREATE_PLANNED_DELIVERY_SUCCESS = createAction(
  '[Deliveries] created planned delivery',
  props<{ orderId: string, posId: string }>()
);

export const CREATE_PLANNED_DELIVERY_ERROR = createAction(
  '[Deliveries] error while creating planned deliveries'
);

export const UPDATE_PLANNED_DELIVERY = createAction(
  '[Deliveries] update planned delivery',
  props<{
    orderId: string,
    posId: string,
    deliveryId: string,
    plannedDate: Date,
    plannedCount: number,
    deliveryComment: string,
    incidentId?: string
  }>()
);

export const UPDATE_PLANNED_DELIVERY_SUCCESS = createAction(
  '[Deliveries] planned delivery updated',
  props<{ orderId: string, posId: string }>()
);

export const UPDATE_PLANNED_DELIVERY_ERROR = createAction(
  '[Deliveries] error while updating planned delivery'
);

export const CANCEL_DELIVERY = createAction(
  '[Deliveries] cancel delivery',
  props<{ deliveryNoteId: string, orderId: string, pseId: string }>()
);

export const CANCEL_DELIVERY_SUCCESS = createAction(
  '[Deliveries] delivery successfully cancelled',
  props<{ orderId: string, posId: string }>()
);

export const CANCEL_DELIVERY_ERROR = createAction(
  '[Deliveries] error while cancelling delivery'
);

export const LOAD_DELIVERIES_CHART = createAction(
  '[Deliveries] load deliveries chart',
  props<{ orderId: string, posId: string }>()
);

export const LOAD_DELIVERIES_CHART_SUCCESS = createAction(
  '[Deliveries] loaded deliveries chart',
  props<{ chartOptions: Options }>()
);

export const LOAD_DELIVERIES_CHART_ERROR = createAction(
  '[Deliveries] error while loading chart'
);

export const DELETE_PLANNED_DELIVERY = createAction(
  '[Deliveries] delete planned delivery',
  props<{ orderId: string, posId: string, deliveryId: string }>()
);

export const DELETE_PLANNED_DELIVERY_SUCCESS = createAction(
  '[Deliveries] deleted planned delivery',
  props<{ orderId: string, posId: string, deliveryId: string }>()
);

export const DELETE_PLANNED_DELIVERY_ERROR = createAction(
  '[Deliveries] error while deleting planned delivery'
);

export const CREATE_DELIVERYNOTE = createAction(
  '[Deliveries] create deliverynote',
  props<{
    orderId: string,
    posId: string,
    deliveryId: string,
    deliveryCount: number,
    deliveryDate: Date,
    deliveryNoteNumber: string,
    deliveryComment: string
  }>()
);

export const CREATE_DELIVERYNOTE_SUCCESS = createAction(
  '[Deliveries] created deliverynote',
  props<{
    orderId: string,
    posId: string,
    deliveryNote: ProleisObject
  }>()
);

export const CREATE_DELIVERYNOTE_ERROR = createAction(
  '[Deliveries] error while creating deliverynote'
);

export const DOWNLOAD_DELIVERYNOTE = createAction(
  '[Deliveries] download deliverynote',
  props<{ noteId: string }>()
);

export const DOWNLOAD_DELIVERYNOTE_SUCCESS = createAction(
  '[Deliveries] downloaded deliverynote'
);

export const DOWNLOAD_DELIVERYNOTE_ERROR = createAction(
  '[Deliveries] error while downloading deliverynote'
);

export const LOAD_DELIVERY_ICONS = createAction(
  '[Deliveries] load icons',
  props<{ deliveries: ProleisObject[] }>()
);

export const LOAD_DELIVERY_ICONS_SUCCESS = createAction(
  '[Deliveries] icons loaded',
  props<{ icons: Map<string, string> }>()
);

export const LOAD_DELIVERY_ICONS_ERROR = createAction(
  '[Deliveries] error while loading icons'
);

export const VALIDATE_PBO_SUBTYPES = createAction(
  '[Deliviries] validate pbo subtypes',
  props<{ pboId: string, pseId: string }>()
);

export const VALIDATE_PBO_SUBTYPES_SUCCESS = createAction(
  '[Deliveries] pbo subtypes validated',
  props<{ pbos: ValidatePboModel[] }>()
);

export const VALIDATE_PBO_SUBTYPES_ERROR = createAction(
  '[Deliveries] error while validating pbo subtypes'
);
